import React from 'react'
import Dictionary from '../../../Classes/Dictionary'
import styles from './CompletionStatus.module.css'

type CompletionStatusProps = {
    status: "Complete" | "Incomplete" | "In Progress" | "In progress" | "Overdue" | "Not started"
}

const statusStyles = new Dictionary<string, { bg: string; color: string; border: string }>([
    ["Complete",     { bg: "rgba(82, 191, 162, 0.12)",  color: "#1a7a5c", border: "rgba(82, 191, 162, 0.3)" }],
    ["Incomplete",   { bg: "rgba(100, 116, 139, 0.08)", color: "#64748b", border: "rgba(100, 116, 139, 0.2)" }],
    ["In Progress",  { bg: "rgba(234, 179, 60, 0.14)",  color: "#92650a", border: "rgba(234, 179, 60, 0.3)" }],
    ["Overdue",      { bg: "rgba(226, 90, 116, 0.12)",  color: "#b63352", border: "rgba(226, 90, 116, 0.3)" }],
    ["Not started",  { bg: "rgba(100, 116, 139, 0.08)", color: "#64748b", border: "rgba(100, 116, 139, 0.2)" }],
]);

const fallback = { bg: "#f1f5f9", color: "#475569", border: "rgba(100, 116, 139, 0.2)" };

const CompletionStatus = ({status} : CompletionStatusProps) => {
    const normalizedStatus = status === "In progress" ? "In Progress" : status;
    const s = statusStyles.tryGetValue(normalizedStatus, fallback) ?? fallback;

    return (
        <div
            className={styles.status}
            style={{ background: s.bg, color: s.color, border: `1px solid ${s.border}` }}
        >
            {normalizedStatus}
        </div>
    );
}

export default CompletionStatus